"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const pathwaySteps = [{
  title: "01. Scoping & Discovery",
  note: "Defining clear business outcomes and fixed-price milestones. We align on deliverables before any work begins.",
  align: "left"
}, {
  title: "02. Strategic Mobilisation",
  note: "Deploying senior-level expertise to establish governance frameworks and high-level architectural roadmaps.",
  align: "right"
}, {
  title: "03. Agile Implementation",
  note: "Executing workstreams with precision. Payment triggers are tied directly to validated project milestones.",
  align: "left"
}, {
  title: "04. Outcome Realisation",
  note: "Final handover, knowledge transfer, and transition to BAU. We ensure your team is equipped for long-term success.",
  align: "right"
}];
export default function DevelopmentPathway() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="55350" id="milestone-methodology" ref={ref} className="relative w-full py-20 overflow-hidden bg-background transition-all duration-700 ease-out opacity-100 translate-y-0 !h-[120px]">
      
    </section>;
}